import { Observable } from 'rxjs';
import { User } from '../../models/user.model';

export abstract class UserData {
  abstract getUsers(): Observable<User[]>;
  abstract getUserById(id:string): Observable<User>;
  abstract addUser(user: User): Observable<User>;
  abstract updateUser(user: User): void;
}